<template>
    <ModalCommon :id="`ModalAddTab`" :config="config" @save="handleSaveAddTab()" @close="handleCloseAddTab()">
        <div class="form-group">
            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('screenRequired.nameTab') }} <span class="text-danger">*</span></label>
            <div class="col-sm-12">
                <InputText
                    :model.sync="dataAddTab.name_tab"
                    :config.sync="tabAddConfig.name_tab"
                    @blur="handleValidateField(dataAddTab.name_tab, tabAddConfig.name_tab)"
                />
            </div>
        </div>
        <div class="form-group">
            <label class="col-sm-3 text-nowrap" style="min-width: 150px"
                >{{ $t('screenRequired.titleTab') }} <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
                <InputText
                    :model.sync="dataAddTab.title_field"
                    :config.sync="tabAddConfig.title_field"
                    @blur="handleValidateField(dataAddTab.title_field, tabAddConfig.title_field)"
                />
            </div>
        </div>
    </ModalCommon>
</template>
<script>
import ModalCommon from '@/components/Modal/main.vue';

import { InputText } from '@/components/Input';
import { validateField, validateAllField } from '@/utils/validate_v2';
import { initAddTab, configAddTab } from '@/views/pages/require/constants';

export default {
    name: 'ModalAddTab',
    components: {
        ModalCommon,
        InputText
    },
    props: {
        config: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            dataAddTab: initAddTab(),
            tabAddConfig: configAddTab()
        };
    },
    methods: {
        handleValidateField(valueField, configField) {
            validateField(valueField, configField);
        },

        handleSaveAddTab() {
            let isValid = validateAllField(this.dataAddTab, this.tabAddConfig);
            if (!isValid) return;
            this.config.model = false;
            this.$emit('save', this.dataAddTab);
        },

        handleCloseAddTab() {
            this.config.model = false;
        }
    },
    watch: {
        'config.model': {
            handler(newValue) {
                if (!newValue) {
                    this.dataAddTab = initAddTab();
                    this.tabAddConfig = configAddTab();
                }
            },
            immediate: true
        }
    }
};
</script>
